/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 10:23:28
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 10:54:39
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/HOC/index.tsx
 */
import _SectionHOC from 'src/layout/EditorPageLayout/EditorCollapsePageLayout/SectionHOC';
import { onCollapseChange, getCollapse } from '../slice';
const SectionHOC = (Component: any, obj) => {
  const _props = { onCollapseChange, getCollapse, ...obj };
  return _SectionHOC(Component, _props);
};
export default SectionHOC;

//import React from 'react';
// const Test = (a) => {
//   const [test, setTest] = React.useState('abc');
//   React.useEffect(() => {
//     console.log('effect');
//     setTimeout(() => setTest('qwe'), 5000);
//   }, []);
//   return <div>{test}</div>;
// };
// export { Test };
